// Tenantra Inc. - Product analytics (PostHog)
import posthog from 'posthog-js';

const KEY = process.env.REACT_APP_POSTHOG_KEY;
const HOST = process.env.REACT_APP_POSTHOG_HOST;

const NO_REPLAY_PATHS = ['/tenant/', '/landlord/verification', '/admin'];

let ready = false;

export function initAnalytics() {
  if (!KEY || ready) return;
  posthog.init(KEY, {
    api_host: HOST,
    person_profiles: 'identified_only',
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: false,
    disable_session_recording: NO_REPLAY_PATHS.some((p) => window.location.pathname.startsWith(p)),
    session_recording: {
      maskAllInputs: true,
      maskTextSelector: '[data-ph-mask], .font-mono',
      blockSelector: 'iframe, img, video, canvas',
    },
  });
  ready = true;
}

export function track(event, properties = {}) {
  if (!ready) return;
  posthog.capture(event, properties);
}

export function identify(user) {
  if (!ready || !user?.id) return;
  posthog.identify(user.id, { role: user.role, plan: user.subscription_tier || user.plan });
}

export function resetAnalytics() {
  if (ready) posthog.reset();
}
